module.exports = __webpack_public_path__ + "fonts/Caveat-SemiBold.1fdd873e.ttf";